import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { Container as MapDiv, NaverMap, Marker } from "react-naver-maps";
import { IntroContainer } from "./styled";

const defaultAddress = "경기도 부천시 신흥로 223";
const domainUrl = window.location.href;

export default function Intro() {
  const navigate = useNavigate();
  const navermaps = window.naver.maps;

  const { cmpnyNo, theme, homepageInfo, url } = useOutletContext();
  const isMobile = useMediaQuery({ query: "(max-width:767px)" });

  const mapRef = useRef(null);
  const scrollRef = useRef();

  const shopCompany = useSelector((state) => state.compoIndex.shopCompany);

  const [cmpnyInfo, setCmpnyInfo] = useState("");
  const [center, setCenter] = useState({ lat: 36.348768969298746, lng: 127.39696329741778 });

  useEffect(() => {
    if (cmpnyNo) {
      getCmpnyInfo();
    }
  }, [cmpnyNo]);

  useEffect(() => {
    if (shopCompany === 0) {
      window.scrollTo(0, 0);
    } else {
      setTimeout(() => {
        scrollRef?.current?.scrollIntoView({ behavior: "auto" });
      }, 200);
    }
  }, [shopCompany]);

  useEffect(() => {
    if (mapRef.current) {
      mapRef.current.panTo(new window.naver.maps.LatLng(center.lat, center.lng));
    }
  }, [center]);

  const getCmpnyInfo = async () => {
    const url = "/api/cmpnyInfo";
    const body = {
      cmpnyNo,
    };
    const res = await axios.post(url, body);
    if (res) {
      setCmpnyInfo(res.data);
      setCenter({ lat: res.data.latitude, lng: res.data.longitude });
    }
  };

  const copyAddress = () => {
    if (!cmpnyInfo.adres) {
      toast.error("주소가 존재하지 않습니다.");
      return;
    }
    navigator.clipboard.writeText(cmpnyInfo.adres);
    toast.success("주소가 복사 되었습니다.");
  };

  const getThemeText = () => {
    const textMap = {
      0: "찾아오시는 길",
      1: "COMPANY",
      2: "WAY TO COME",
      3: "오시는 길",
      4: "오시는 길",
    };

    return textMap?.[theme] || "";
  };

  return (
    <IntroContainer className={`theme-${theme}`}>
      <div className="section">
        <div className="content">
          {homepageInfo?.cmpnyIntroduce ? (
            <div dangerouslySetInnerHTML={{ __html: homepageInfo.cmpnyIntroduce }}></div>
          ) : (
            <div>안녕하세요, {homepageInfo?.cmpnyNm}입니다.</div>
          )}
          {theme === 4 && (
            <button
              onClick={() =>
                navigate(`/shop/${url}/shoppingNotice?page=0`, { state: { tabIndex: 1 } })
              }>
              문의하기
            </button>
          )}
        </div>
      </div>
      <div className="section">
        <h3>
          <span>{getThemeText()}</span>
        </h3>
        <div className="map">
          {cmpnyInfo?.adres && (
            <div className="addr">
              <span>{cmpnyInfo.adres}</span>
              <button onClick={copyAddress}>
                <i className="fa fa-copy"></i> 복사
              </button>
            </div>
          )}
          <div className="naverMap">
            <MapDiv
              style={{
                width: "100%",
                height: 400,
              }}>
              <NaverMap
                ref={mapRef}
                center={new navermaps.LatLng(center.lat, center.lng)}
                defaultZoom={13}>
                <Marker position={new navermaps.LatLng(center.lat, center.lng)} title="회사 위치" />
              </NaverMap>
            </MapDiv>
          </div>
        </div>
      </div>
    </IntroContainer>
  );
}
